export default __webpack_public_path__ + "609173e0cb005336d8782cdb977f8491.svg";